import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { ConfigurationService } from '../../shared/services/configuration.service';
import flatten from 'lodash-es/flatten';
import { environment } from '../../../environments/environment';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { MenuPortal } from '../../shared/enums/menu-portal.enum';
import { MenuItem } from '../../shared/interfaces/menu-item.interface';
import { PortalCountry } from '../../shared/interfaces/portal-country.interface';
import { Country } from '../../shared/interfaces/country.interface';
import { Member } from '../../shared/interfaces/member.interface';
import { CorporateNavigation } from '../../shared/enums/corporate-navigation.enum';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateParam, DynamicRoute } from '../../common/interfaces';
import { MetaTagConstants } from '../../shared/constants/meta-tag.constants';
import { SharedConstants } from '../../shared/constants/shared.constants';
import { MapLocationInfo } from 'src/app/shared/interfaces/map-location-info.interface';
import { Subscription } from 'rxjs/Subscription';
import { SEOService } from 'src/app/shared/services/seo.service';

@Component({
  selector: 'app-static-template',
  templateUrl: '../templates/template1/views/static-template.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/static-template.component.less'
  ]
})
export class StaticTemplateComponent implements OnInit, OnDestroy {
  isoCountryCode: string;
  languageCode: string;
  translateParams: TranslateParam;
  contentHtml = ``;
  sitemapId: number;
  slug: string;
  cdnPath: string;
  menus: any = [];
  appSites: MenuItem[];
  store: StoreConfig;
  activeIndex = 0;
  customCatalogs: any[] = [];
  portalCountries: Country[] = [];
  userInfo: Member;
  corporateNavigation = CorporateNavigation;
  mapLocation: MapLocationInfo;
  eventSubscription: Subscription;

  constructor(
    private _commonService: CommonService,
    private _route: ActivatedRoute,
    private _cacheService: CacheService,
    private _configurationService: ConfigurationService,
    private _router: Router,
    private meta: Meta,
    private title: Title,
    private seoService: SEOService
  ) {
    }
  ngOnInit() {
    if (environment.dataLayer && environment.dataLayer.length > 0) {
      environment.dataLayer[0].pageCategory = 'corporate-home';
    }
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.cdnPath = environment.cdnURL;
    this.store = this._cacheService.get(CacheKey.StoreConfiguration);
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    this.subscribeMenu();
    this.getAllPortalCountries();
    this.getMapLocation();
  }

  subscribeMenu(): void {
    this._route.params.subscribe((params: any) => {
      this.slug = params['slug'];
      this.sitemapId = null;
      const store: StoreConfig = this._configurationService.getStoreData();
      const countryId: number = this._cacheService.getCookieValue(CacheKey.CountryId);
      const languageCode: string = this._cacheService.getCookieValue(CacheKey.languageCode);
      const memberTypeId = MemberLevel.RETAIL;
      const portalID = MenuPortal.Corporate;
      if (store && store.id && countryId) {
        this.getApplicationSites(portalID, store.id, countryId, languageCode, memberTypeId)
      }
    });
  }
  /**
   * To application content based upon menus
   * @param {number} portalID
   * @param {number} storeId
   * @param {number} countryId
   * @param {string} languageCode
   * @param {number} memberTypeId
   * @memberof StaticTemplateComponent
   */
  getApplicationSites(portalID: number, storeId: number, countryId: number, languageCode: string, memberTypeId: number) {
    this._commonService.getApplicationSites(portalID, storeId, countryId, languageCode, memberTypeId)
      .subscribe(sites => {
        if (sites && sites.length > 0) {
          this.appSites = sites;
          this.getContent();
        } else {
          this.gotoNotFound();
        }
      });
  }
  // To fetch the cms data from service
  loadCmsData(sitemapId: number): void {
    const store: StoreConfig = this._configurationService.getStoreData();
    if (store && sitemapId) {
      this._commonService
        .getCMSContentBySiteMapId(sitemapId, store.homeIsocodeThree, store.id, environment.portalId)
        .subscribe((response: any) => {
          if (response.pageContent) {
            this.contentHtml = response.pageContent;
          }
          if (response.customCatalogs) {
            this.customCatalogs = response.customCatalogs;
          }
          if (response) {
            const metaTitle = response.metaTitle || MetaTagConstants.metaTitle;
            const metaDescription = response.metaDescription || MetaTagConstants.metaDescription;
            // Canonical Tag
            this.seoService.addCanonicalURL(response.canonicalURL)
            this.title.setTitle(metaTitle);
            this.meta.updateTag({ name: 'description', content: metaDescription });
          }
        }, (error: any) => {
          this.translateParams = this._commonService.handleError(error);
        });
    }
  }


  getContent() {
    this.menus = this.appSites;
    let obj: any;
    if (!this.slug) {
      this.slug = 'home';
    }
    const menu = this.menus.find((item: MenuItem) => item.slug === this.slug);
    if (menu && menu.siteMapId) {
      this.loadCmsData(menu.siteMapId);
    }  else {
      this.gotoNotFound();
    }
    // obj = _(this.menus)
    //   .thru(function (coll: any) {
    //     return _.union(coll, _.map(coll, 'childs'));
    //   })
    //   .flatten()
    //   .find({ slug: this.slug });
    // if (obj) { this.sitemapId = obj.siteMapId; }
    // if (this.sitemapId) {
    //   this.loadCmsData(this.sitemapId);
    // } else {
    //   this.gotoNotFound();
    // }
  }

  /**
   * set country and default language if only country code is in URL
   */
  setCountryAndLanguageByCountryCodeURL() {
    const url = window.location.pathname.split('/');
    if (url && url.length === 2 && this.store) {
      window.location.href = decodeURIComponent(encodeURIComponent(window.location.origin + '/'
        + this.store.homeIsocodeThree.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/home'));
    } else {
      const country = this.portalCountries.find(item => item.isocodeThree.toLowerCase() === this.isoCountryCode.toLowerCase());
      if (country) {
        if (this.userInfo && this.userInfo.memberAllowedCountries && this.userInfo.memberAllowedCountries.length > 0) {
          const memberAllowedCountry = this.userInfo.memberAllowedCountries
            .find(item => item.isoCodeThree === country.isocodeThree && item.authorized);
          if (memberAllowedCountry) {
            this._commonService.navigateToLegacy(country.isocodeThree).subscribe(response => {
              if (response) {
                window.location.href = decodeURIComponent(encodeURIComponent(response.redirectUrl +
                  '?store=' + response.store + '&idtoken=' + response.idToken));
              }
            });
          }
        } else {
          window.location.href = environment.legacyURL + country.isocodeThree.toLowerCase() + '/'
            + country.defaultLangName.toLowerCase();
        }
      }
    }
  }

  /**
   * Get all Portal Countries
   */
  getAllPortalCountries() {
    if (!this._cacheService.get(CacheKey.PortalCountries)) {
      this._commonService.getPortalCountries().subscribe((portalCountries: PortalCountry[]) => {
        if (portalCountries && portalCountries.length > 0) {
          this.portalCountries = flatten(
            portalCountries.map(portal => portal.countries));
        }
      });
    }
  }

 /**
  * @description
  * @date 2018-10-03
  * @param {string} route
  * @memberof ProductComponent
  */
  navigateToPortal(dynamicRoute: DynamicRoute): void {
    let route = dynamicRoute.route;
    if (route) {
      if (environment.betaPortal) {
        let skipNavigation = this._commonService.checkSkipNavigation(this.isoCountryCode);
        if (skipNavigation) {
          if (this._commonService.navigateToInternalPreview(route)) {
            const url = route.split('/');
            this.navigateToPreviewPage(url, dynamicRoute, route);
            return;
          }
        } else {
          route = this._commonService.constructBetaUrl(route);
          // if (route && route.indexOf(window.location.origin) > -1) {
          //   const url = route.split('/');
          //   this.navigateToPreviewPage(url);
          //   return;
          // }
        }
      }
      window.open(route, dynamicRoute.target);
    }
  }

  /**
   * Navigate to BETA portal
   * @param route 
   */
  navigateToBetaUrl(route: string) {
    if (route !== undefined && route !== null && route !== '') {
      let url = new URL(route);
      let redirectHostName = this.findOutPortal(url.host);
      let newRedirectUrl = redirectHostName + url.pathname;
      window.location.href = newRedirectUrl.toString();
    }
  }

  findOutPortal(url: string) {
    if (url.toLowerCase().includes('join')) {
      return environment.enrollSiteURL;
    }
    else if (url.toLowerCase().includes('shop')) {
      return environment.shopURL;
    }
    else if (url.toLowerCase().includes('account')) {
      return environment.accountSiteURL;
    }
    else if (url.toLowerCase().includes('corporate')) {
      return environment.corporateUrl;
    }
  }

  
  /**
   * @description
   * @date 2020-01-20
   * @param {string[]} url
   * @param {DynamicRoute} dynamicRoute
   * @param {string} route
   * @memberof StaticTemplateComponent
   */
  navigateToPreviewPage(url: string[], dynamicRoute: DynamicRoute, route: string): void {
    let slug: string;
    if (dynamicRoute && dynamicRoute.target === SharedConstants.NEW_TAB) {
      window.open(route, dynamicRoute.target);
    } else if (url && url.length) {
      slug = url[url.length - 1];
      slug = slug.indexOf('?') > -1 ? slug.split('?')[0] : slug;
      this._commonService.scrollByValue(0, 0, 0);
      this._router.navigate(['./' + this.isoCountryCode.toLowerCase()
        + '/' + this.languageCode.toLowerCase() + '/' + slug]);
    }
  }

  /**
   * Goto NotFound Page
   * @returns void
   */
  gotoNotFound(): void {
    this._router.navigate(['/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase() + '/notfound']);
  }

  /**
  * @description get country contact information based on map location
  * @date 2020-01-21  * @memberof StaticTemplateComponent
  */
  getMapLocation(): void {
    const homeCoutryCode = this.store && this.store.operatingCountry;
    this._commonService.getMapLocations().subscribe((response: MapLocationInfo[]) => {
      this.mapLocation = response.find(item => item.countryCode.toLowerCase() === this.isoCountryCode.toLowerCase())
      || response.find(item => item.countryCode.toLowerCase() === homeCoutryCode.toLowerCase());
    });
  }

  /**
   * Remore meta title and Description
   *
   * @memberof AppCmsComponent
   */
  ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

}
